export default __webpack_public_path__ + "static/media/demonologist.8095233b.png";